/* @flow */

import * as React from 'react';

import Rive from '@rive-app/react-canvas';

import {TrialGatheringLayout} from 'shells/trial-gathering/trial-gathering-layout';

import {TinyIntroCheckboxButtons} from '../../fields/tiny-intro-checkbox-buttons';

import {ANIMATION_SRC, NUMBER_OF_STEPS, DATA_SOURCE_OPTIONS} from '../consts';

type Props = {|
    onSkip: () => void,
    onBack: () => void,
    onNext: () => void,
    whereIsYourData: string[],
    setWhereIsYourData: (whereIsYourData: string[]) => void,
    handleStepViewed: () => void,
|};

export function WhereIsYourData(props: Props) {
    React.useEffect(() => {
        props.handleStepViewed();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <TrialGatheringLayout
            prompt='Where is your data today?'
            instructions='Select all that apply'
            currentStep={4}
            totalSteps={NUMBER_OF_STEPS}
            animation={<Rive src={ANIMATION_SRC.WHERE_IS_YOUR_DATA} />}
            animationBackgroundColor='productBgHovered'
            onSkip={props.onSkip}
            onBack={props.onBack}
            onNext={props.onNext}
        >
            <TinyIntroCheckboxButtons
                title=''
                options={DATA_SOURCE_OPTIONS}
                variant='controlled'
                name='checkboxbuttons'
                value={props.whereIsYourData}
                onChange={props.setWhereIsYourData}
            />
        </TrialGatheringLayout>
    );
}
